<template lang="pug">
.box_main(:materType="curVideo.materialType")
  .left
    .dropdown_div
      OrderVideoDropdown(v-model="curVideo" :list="materialInfoList" :orderGuid="order.guid")
    div
      .video_part(v-if="curVideo && curVideo.materialContent")
        img(v-if="isWifi" :src="curVideo.narrowImageUrl || wifiIcon" @click="openWifiWindow")
        img(v-else-if="curVideo.materialType == 5" :src="curVideo.narrowImageUrl || h5Icon" @click="openWifiWindow")
        video(v-else-if="curVideo.materialType == 1" :src="curVideo.materialContent" @click="playVideo")
        img(v-else-if="curVideo.materialType == 2" :src="curVideo.materialContent" @click="playVideo")
      .no_material(v-else)
        .text_main 请上传{{typeStr}}
  .message_part
    h6 {{(order.advContentDto && order.advContentDto.contentName) || '虚位以待'}}
    p
      span.color_999 审核状态：
      span.shenhezhong(v-if="order.execStatus == 1") 审核中
      span.zhengque(v-else-if="order.execStatus == 2") 审核成功
      span.cuowu(v-else-if="order.execStatus == 3") 审核失败
      span(v-else) --
      //- span {{checkStatusName}}
      //- el-popover(v-if="curVideo && curVideo.reason")
        span {{curVideo.reason || ''}}
        span.rs(slot="reference") 原因说明
    p(v-if="order.valuationType == 3")
      span.color_999 起始日期：
      span {{order.startDate}}（预计投放{{order.validDays || 0}}天）
    p(v-else)
      span.color_999 投放日期：
      span {{order.startDate}} ~ {{order.endDate}}
    p(v-if="curVideo.materialType == 1")
      span.color_999 视频时长：
      span {{curVideo.materialDuration ? (curVideo.materialDuration/1000).toFixed(2) + '秒' : '--'}}
    p(v-if="curVideo.materialType == 2")
      span.color_999 单次曝光：
      span {{curVideo.materialDuration ? (curVideo.materialDuration/1000).toFixed(2) + '秒' : '--'}}
    p
      span.color_999 覆盖小区：
      span {{order.nbhdCount}}
      span.color_999.right(v-if="order.valuationType == 3") 流量：
      span(v-if="order.valuationType == 3") {{order.budgetAmount || 0}}千人次
    p
      span.color_999 屏幕数量：
      span {{order.deviceGuids}}个
    .operation
      button(@click="goUrl('/mapOrderDetail', { id: order.guid })") 查看订单
      span.line
      //- button(@click="changeMatial(order, 'showUpload')") {{isUpdate ? '更换素材' : '上传素材'}}
      button(@click="changeMatial(order, 'showUpload')") {{opTypeStr}}{{typeStr}}
</template>

<script>
import wifiIcon from '../../assets/wifi_ad_icon.png'
import h5Icon from '../../assets/h5_icon.png'
import Vue from 'vue'
import OrderVideoDropdown from './orderVideo_dropdown'
export default {
  name: 'orderVideoItem',
  components: { OrderVideoDropdown },
  props: {
    order: {
      type: Object,
      default: {}
    },
    pType: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      curVideo: {},
      wifiIcon
    }
  },
  watch: {
    order: {
      immediate: true,
      handler(v) {
        let advContentDto = this.order.advContentDto || {}
        let ftData = advContentDto.materialInfoList
        if (ftData && ftData.length) {
          this.curVideo = ftData[0] || {}
        }
      }
    }
  },
  computed: {
    materialInfoList() {
      return (this.order && this.order.advContentDto && this.order.advContentDto.materialInfoList) || []
    },
    isUpdate() {
      return this.order.advContentDto && this.order.advContentDto.customerGuid
    },
    checkStatusName() {
      if (this.order.execStatus === '1') return '审核中'
      if (this.order.execStatus === '2') return '审核通过'
      if (this.order.execStatus === '3') return '未通过'
      return '--'
    },
    isWifi() {
      return this.order.screenArea && this.order.screenArea == 3
    },
    opTypeStr() {
      return Number(this.order.execStatus) > 0 ? '更换' : '上传';
    },
    typeStr() {
      return this.isWifi ? 'URL' : '素材';
      // return row => {
      //     return row.screenArea && row.screenArea == 3 ?
      // }
    }
  },
  methods: {
    showImg() {
      let curInstan = this
      let imgContructor = Vue.merge({
        render: function (createElement) {
          return createElement(
            'el-dialog'
          )
        }
      })
      let imgInstan = new imgContructor()
      document.body.appendChild(imgInstan.$el)
    },
    changeMatial(row, type) {
      this.$emit('changeMatial', row, type)
    },
    openWifiWindow() {
      window.open(this.curVideo.materialContent)
    },
    playVideo(e) {
      let ele = e.target
      let fn = ele.requestFullscreen || ele.mozRequestFullScreen || ele.webkitRequestFullScreen
      fn.bind(ele)() // 展示全屏, 直接执行 fn 会报错，须bind指定 ele 执行 fn 方法
      if (ele.tagName == 'VIDEO') ele.play() // 播放视频
    }
  }
}
</script>

<style lang="sass" scoped>
.icon-shenhezhong, .shenhezhong
    color: #FF7413
.icon-daishangchuan, .daishangchuan
    color: #999
.icon-zhengque, .zhengque
    color: #3FB536
.icon-cuowu, .cuowu
    color: #D50000

.sts_color
    &.ing
        color: #FF7413
    &.icon-daishangchuan
        color: #999
    &.ok
        color: #3FB536
    &.nok
        color: #D50000
.box_main
    border: 1px solid #e9e9e9
    overflow: hidden
    border-radius: 10px
    background: #fff
    height: 262px
    box-shadow: 0px 6px 20px 0px rgba(0,0,0,0.09)
    .left
        width: 180px
        padding: 20px 10px
        float: left
    .dropdown_div
        padding: 0 10px
        height: 40px
        line-height: 40px
        margin-bottom: 10px
        width: 100%
        border: 1px solid #E9E9E9
        border-radius: 4px
.video_part
    float: left
    position: relative
    height: 170px
    background: #000
    width: 100%
    text-align: center
    video
        width: 100%
        height: 100%
        cursor: pointer
    img
        max-width: 100%
        max-height: 100%
        cursor: pointer
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
    .tip
        position: absolute
        width: 135px
        bottom: 12px
        left: 10px
        line-height: 30px
        color: #FFF
        text-align: center
.message_part
    // width: 304px //304px在firfox下会出现广告信息与广告缩略图重叠现象，改用min-width
    // min-width: 303px
    height: 100%
    width: calc(100% - 180px)
    float: left
    padding: 20px
    text-align: left
    border-left: 1px solid #E9E9E9
    border-radius: 10px
    h6
        font-size: 16px
        margin-bottom: 15px
        font-weight: 600
        height: 20px
        text-overflow: ellipsis
        overflow: hidden
        white-space: nowrap
    p
        line-height: 20px
        margin-bottom: 10px
        .rs
            margin-left: 10px
            padding-left: 10px
            border-left: 1px solid #e9e9e9
            color: #6296FF
            cursor: pointer
        span.right
            display: inline-block
            margin-left: 10px
            padding-left: 10px
            border-left: 1px solid #E9E9E9
            line-height: 1
    .operation
        margin-top: 20px
        button
            width: 116px
            height: 30px
            border-radius: 4px
            border: none
            color: #FFF
            font-size: 12px
            cursor: pointer
            background: linear-gradient(315deg, #FF846D 0%, #FF3973 100%)
            &:first-child
                border: 1px solid #D4D4D4
                color: #282729
                background: #FFF
        .line
            border-left: 1px solid #E9E9E9
            margin: 0 10px
.no_material
    float: left
    width: 100%
    .text_main
        width: 100%
        height: 170px
        line-height: 170px
        text-align: center
        background: #E9E9E9
</style>

